import script from "./DefaultCarrierView.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultCarrierView.vue?vue&type=script&setup=true&lang=js"

import "./DefaultCarrierView.vue?vue&type=style&index=0&id=ae2d916c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae2d916c"]])

export default __exports__